module.exports = __webpack_public_path__ + "img/2.f4e19d0b.jpg";